import React, { useEffect, useState } from 'react';
import walletService from './payService';
import './css/WalletContent.css';
import authService from '../auth/authService';
import labService from '../lab/labService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileInvoiceDollar, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import HashLoader from "react-spinners/HashLoader";

const WalletContent = () => {
    const [currentUser, setCurrentUser] = useState(null);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [sortConfig, setSortConfig] = useState({ key: 'created', direction: 'descending' });
    const [payments, setPayments] = useState([]);
    const [histLoading, setHistLoading] = useState(true);
    const [selectedAmount, setSelectedAmount] = useState(10);


    useEffect(() => {
        const fetchUserData = async () => {
            const userData = localStorage.getItem('user');
            if (!userData) {
                setLoading(false);
                return;
            }

            const parsedUserData = JSON.parse(userData);
            const token = parsedUserData.access;
            if (!token) {
                setLoading(false);
                return;
            }

            try {
                const response = await labService.getUserInfo(token);
                setUser(response.data);
            } catch (error) {
                console.error('Error fetching user data', error);
            } finally {
                setLoading(false);
            }
        };

        fetchUserData();
    }, []);

    useEffect(() => {
        const user = authService.getCurrentUser();
        setCurrentUser(user);
    }, []);

    useEffect(() => {
        if (currentUser) {
            walletService.listPayments(currentUser.access).then(response => {
                console.log(response.data)
                setPayments(response.data);
                setHistLoading(false)
            }).catch(error => {
                console.error(error);
            });
        }
    }, [currentUser]);


    const handlePurchase = async (amount) => {
        try {
            const token = currentUser.access
            const data = await walletService.purchaseTokens(token, amount);
            window.location.href = data.url;
        } catch (error) {
            console.error('Error during purchase:', error);
        }
    };

    const sortedPayments = [...payments].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
    });

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const getSortIndicatorClass = (key) => {
        if (sortConfig.key === key) {
            return sortConfig.direction === 'ascending' ? 'ascending' : 'descending';
        }
        return '';
    };

    return (
        <div className='wallet-content'>
            <div className='header-content'>
                    <h2 className='pred-over'>Wallet</h2>
            </div>
            
            <p className='wallet-txt'>
                <svg style={{color: 'rgb(27, 69, 129)'}} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-exclamation-circle-fill svg-wall" viewBox="0 0 16 16">
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4m.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2"/>
                </svg>
                Making predictions with <strong>QL Chemicals</strong> requires tokens. Once added, tokens are non-refundable and can only be used within the application.
            </p>
            <div className='up-wallet'>
                <div className='wallet-status'>
                    <div className='info-wallet'>
                    </div>
                    <div className='wallet'>
                        <p className='ws'>Wallet status</p>
                        <p className='token-number'>{user ? `${user.coins} tokens`  : 'Loading...'}</p>
                    </div>
                </div>
                <div className='top-up'>
                    <h3 className='tu'>Top up your wallet</h3>
                    <div className='buy-options'>
                        <div 
                            className={`buy-opt ${selectedAmount === 1 ? 'active-buy-opt' : ''}`} 
                            onClick={() => setSelectedAmount(1)}
                        >
                            <div className='nr-token'>
                                1 token
                            </div>
                            <div className='tok-price'>9.99$</div>
                        </div>
                        <div 
                            className={`buy-opt ${selectedAmount === 10 ? 'active-buy-opt' : ''}`} 
                            onClick={() => setSelectedAmount(10)}
                        >
                            <div className='nr-token'>
                                10 tokens
                            </div>
                            <div className='tok-price'>89.99$</div>
                        </div>
                            <div 
                                className={`buy-opt ${selectedAmount === 100 ? 'active-buy-opt' : ''}`} 
                                onClick={() => setSelectedAmount(100)}
                            >
                            <div className='nr-token'>
                                100 tokens
                            </div>
                            <div className='tok-price'>849.99$</div>
                        </div>
                    </div>
                    <button 
                        className='purchase-btn' 
                        disabled={!selectedAmount}
                        onClick={() => handlePurchase(selectedAmount)}
                    >
                        Continue with this amount
                    </button>

                    <div className='wall-notes'>
                        <div>
                            <FontAwesomeIcon className='env-wall' icon={faEnvelope} />
                        </div>
                        <div>
                            <p className='note-wallet'>Looking for an <strong>enterprise or academic</strong> license?</p>
                            <p className='note-wallet'>
                                Contact us via the <a href="#/contact" className="contact-link">form</a> to receive a personalized quote.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='pay-history'>
                {histLoading ? (
                    <div>
                        <h3 className='ph'>Payment history</h3>
                        <div className='loader-div'>
                            
                            <HashLoader className='loader' size={120} color='#0b5578' />
                        </div>
                    </div>
                ) : sortedPayments.length === 0 ? (
                    <div className='no-pay'>
                        <h3 className='ph'>Payments history</h3>
                        <p className='no-payments'>No payments to display</p>
                    </div>
                ) : (
                    <div className='table-container'>
                        <h3 className='ph'>Payment history</h3>
                        <table className='payments-table'>
                            <thead>
                                <tr>
                                    <th onClick={() => handleSort('created')} className={getSortIndicatorClass('created')}>Purchase Date</th>
                                    <th onClick={() => handleSort('amount')} className={getSortIndicatorClass('amount')}>Price</th>
                                    <th onClick={() => handleSort('status')} className={getSortIndicatorClass('status')}>Status</th>
                                    <th className='download-invoice'>Invoice</th>
                                </tr>
                            </thead>
                            <tbody>
                                {sortedPayments.map((payment,idx) => (
                                    <tr className={`tr-color ${idx % 2 === 0 ? 'odd-row' : ''}`} key={payment.id}>
                                
                                        <td>{payment.created}</td>
                                        <td>{payment.amount} $</td>
                                        <td className={`td-stat ${payment.status.toLowerCase()}`}>{payment.status}</td>
                                        <td className='download-invoice'>
                                            {payment.invoice_url ? (
                                                <a 
                                                    href={payment.invoice_url} 
                                                    target="_blank" 
                                                    rel="noopener noreferrer" 
                                                >   
                                                    <FontAwesomeIcon className='down-inv-icon' icon={faFileInvoiceDollar} />
                                                </a> ) :
                                                (
                                                    <div></div>
                                                )
                                            }
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
            
        </div>


    );
};

export default WalletContent;
